import { Button } from "antd";
import { CheckCircleOutlined, LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import { EstadoGuardado } from "./useAutoguardado";

interface IProps {
  estado: EstadoGuardado;
  texto: string;
  reintentar: () => void;
}

const ICONOS: { [estado: string]: any } = {
  guardando: <LoadingOutlined className="font-color-0051E6" />,
  guardado: <CheckCircleOutlined className="font-color-00904C" />,
  error: <WarningOutlined className="font-color-DB2828" />,
};

/**
 * Dice si lo que la persona escribio ya quedo guardado.
 *
 * Se mantiene discreto: sin el, el autoguardado seria invisible y no habria
 * forma de saber si vale la pena cerrar la pagina.
 */
export const IndicadorGuardado = ({ estado, texto, reintentar }: IProps) => {
  if (estado === "inactivo" || texto === "") return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="d-flex align-items-center font-family-Montserrat-Regular font-size-12px"
      style={{ gap: 6 }}
    >
      {ICONOS[estado]}
      <span>{texto}</span>
      {estado === "error" && (
        <Button type="link" className="font-size-12px" onClick={reintentar}>
          Reintentar
        </Button>
      )}
    </div>
  );
};
